import {
  SET_BREADCRUMBS,
  SET_IS_GENERATED,
  SET_IS_GENERATING,
  SET_SIDEBAR_COLLAPSED,
  SET_SELECTED_COUNTRY,
  SET_SELECTED_PRODUCT,
  SET_SELECTED_LANGUAGE,
} from "./actionTypes";

export const setBreadcrumbs = (breadcrumbs) => ({
  type: SET_BREADCRUMBS,
  payload: breadcrumbs,
});

export const setIsGenerated = (isGenerated) => ({
  type: SET_IS_GENERATED,
  payload: isGenerated,
});

export const setIsGenerating = (isGenerating) => ({
  type: SET_IS_GENERATING,
  payload: isGenerating,
});

export const setSidebarCollapsed = (isCollapsed) => ({
  type: SET_SIDEBAR_COLLAPSED,
  payload: isCollapsed,
});

export const setSelectedCountry = (country) => ({
  type: SET_SELECTED_COUNTRY,
  payload: country,
});

export const setSelectedProduct = (product) => ({
  type: SET_SELECTED_PRODUCT,
  payload: product,
});

export const setSelectedLanguage = (language) => ({
  type: SET_SELECTED_LANGUAGE,
  payload: language,
});
